import React from "react";
import {
  Box,
  Typography,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  Tooltip,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

const ResultsHeader = ({
  totalResults,
  resultsCount,
  handleResultsCountChange,
  isMobileView,
  label,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "rgb(255, 255, 255)",
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px",
        mt: "8px",
        p: "16px 16px 8px 16px",
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          backgroundColor: "rgba(15, 72, 128, 0.08)",
          borderRadius: "6px",
          padding: "6px 12px",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          "&:hover": {
            backgroundColor: "rgba(15, 72, 128, 0.12)",
            transform: "translateY(-1px)",
            boxShadow: "0 2px 4px rgba(15, 72, 128, 0.1)",
          },
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontSize: { xs: "0.75rem", sm: "0.875rem" },
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <span
            style={{
              color: "#0F4880",
              fontSize: { xs: "0.875rem", sm: "1rem" },
              fontWeight: 700,
            }}
          >
            {totalResults?.toLocaleString()}
          </span>
          <span
            style={{
              color: "rgba(15, 72, 128, 0.7)",
              fontWeight: 500,
            }}
          >
            {label}
          </span>
        </Typography>
        <Tooltip
          title={`Total number of ${label.toLowerCase()} in the database`}
        >
          <InfoIcon
            sx={{
              color: "rgba(15, 72, 128, 0.6)",
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
              transition: "all 0.2s ease",
              "&:hover": {
                color: "#0F4880",
                transform: "scale(1.1)",
              },
            }}
          />
        </Tooltip>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center" }}>
        <InputLabel
          sx={{
            display: isMobileView ? "none" : "block",
            marginRight: "4px",
            fontSize: "13px",
            color: "#555",
            fontWeight: "500",
          }}
          htmlFor="resultsCount"
        >
          Show:
        </InputLabel>
        <FormControl
          variant="outlined"
          sx={{
            width: isMobileView ? 90 : 100,
            "& .MuiOutlinedInput-root": {
              borderRadius: "6px",
              height: "32px",
              padding: "8px",
            },
            "& fieldset": {
              borderColor: "#ddd",
              borderWidth: "1px",
            },
            "& .MuiSelect-icon": { right: "4px" },
            "& .MuiSelect-select": {
              padding: "0px",
              display: "flex",
              alignItems: "center",
            },
          }}
        >
          <Select
            id="resultsCount"
            value={resultsCount}
            onChange={handleResultsCountChange}
            sx={{
              fontSize: { xs: "12px", md: "13px" },
              height: "32px",
              bgcolor: "#fff",
            }}
          >
            <MenuItem value={10} sx={{ fontSize: { xs: "12px", md: "13px" } }}>
              10 results
            </MenuItem>
            <MenuItem value={20} sx={{ fontSize: { xs: "12px", md: "13px" } }}>
              20 results
            </MenuItem>
            <MenuItem value={50} sx={{ fontSize: { xs: "12px", md: "13px" } }}>
              50 results
            </MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

export default ResultsHeader;
